/**
 * Reveal-on-scroll for Heal The Earth sections.
 *
 * Opt in per section with the "Reveal on scroll" setting, which adds
 * data-hte-reveal to the section wrapper. Descendants marked [data-reveal]
 * fade and rise in as they enter the viewport. The Corporate Gifting pages
 * use the older `.htg .rise` markup; both selectors are handled so those
 * pages keep working unchanged.
 *
 * Everything degrades to "just show it": no IntersectionObserver, or a
 * reduced-motion preference, reveals every element immediately.
 */
(function () {
  if (window.__hteMotion) return;
  window.__hteMotion = true;

  var SELECTOR = '[data-hte-reveal] [data-reveal]:not(.in), .htg .rise:not(.in)';

  function revealAll(els) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('in');
  }

  function init() {
    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      revealAll(els);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', init);
})();
